<template>
    <v-dialog
            v-model="alertDialog"
            max-width="290"
    >
        <v-card>
            <v-card-title class="headline">
                <span class="orange--text">Atenção</span>
            </v-card-title>

            <v-card-text>
                {{alertDialogText}}
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn
                        color="primary darken-1"
                        text
                        @click="alertDialog = false"
                >
                    Ok, entendi
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        name: "Dialog",
        props: {
            alertDialog: {
                type: Boolean,
                required: false
            },
            alertDialogText: {
                type: String,
                required: false
            },
        },
    }
</script>
